import { Fragment, useEffect, useState } from "react";
import { useMatch, useNavigate } from "react-router";
import { findIndex, first, replace, map } from 'lodash';
import { Paths } from "../routes/Routes";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { useLazyQuery } from "@apollo/client";
import { GET_USERS, GET_USER_WITH_STREAKS } from "../../graphQL/queries";
import { User } from "../../models/User";
import { renderPeriod } from "../../helpers/renderHelper";
import LoadingSpinner from "../common/LoadingSpinner";
import { setUsers } from "../../redux/appStateSlice";
import DriverCard from "../common/DriverCard";
import IncidentCard from "../common/IncidentCard";
import NoContent from "../common/NoContent";
import { buildIncidents } from "../../helpers/incidentHelper";
import { buildGroupDrivers } from "../../helpers/managerHelper";
import { navigatToDriverDetail } from "../../helpers/navigationHelper";
import { incrementBackNavigation } from "../../redux/navigationSlice";
import ScoreTile from "../common/ScoreTile";
import { AppMessages } from "../../strings";
import RankProgress from "../common/RankProgress";
import StreakSection from "../common/StreakSection";

const ManagerDriverDetail = () => {

	const driverDetailMatch = useMatch(Paths.MANAGER_DRIVER_DETAIL);
	const navigate = useNavigate()
	const dispatch = useAppDispatch();
	const currentGroupID = parseInt(driverDetailMatch?.params.groupid ?? "-1")

	const [currentDriver, setCurrentDriver] = useState<User|undefined>()
	const currentOrganization = useAppSelector(state => state.appState.currentOrganization);
	const allDrivers = useAppSelector(state => state.appState.groupUsers[currentGroupID]?.users)
	const drivers = buildGroupDrivers(allDrivers);

	const [getDriver, driverResponses ] = useLazyQuery(GET_USER_WITH_STREAKS);

	const [getDrivers, getDriversResponses ] = useLazyQuery(GET_USERS);

	useEffect(()=> {
		getDriver({
			variables: {
				userID: parseInt( driverDetailMatch?.params.id ?? "-1"),
				onlyDrivers: true,
				startDate: import.meta.env.REACT_APP_MANAGER_START_DATE ? import.meta.env.REACT_APP_MANAGER_START_DATE : null,
				endDate: import.meta.env.REACT_APP_MANAGER_END_DATE ? import.meta.env.REACT_APP_MANAGER_END_DATE : null,
				prevStartDate: import.meta.env.REACT_APP_MANAGER_PREV_START_DATE ? import.meta.env.REACT_APP_MANAGER_PREV_START_DATE : null,
				prevEndDate: import.meta.env.REACT_APP_MANAGER_PREV_END_DATE ? import.meta.env.REACT_APP_MANAGER_PREV_END_DATE : null
			}
		});
	},[getDriver, driverDetailMatch?.params.id]);

	useEffect(() => {
		if (driverResponses?.data) {
			// console.log('driverResponses?.data = ', driverResponses?.data)
			const driver = first(driverResponses?.data.users)
			if (driver) {
				setCurrentDriver(driver)
				//console.log("called get all drivers")
				getDrivers({
					variables: {
						groupID: currentGroupID,
						onlyDrivers: true,
						startDate: import.meta.env.REACT_APP_MANAGER_START_DATE ? import.meta.env.REACT_APP_MANAGER_START_DATE : null,
						endDate: import.meta.env.REACT_APP_MANAGER_END_DATE ? import.meta.env.REACT_APP_MANAGER_END_DATE : null,
						prevStartDate: import.meta.env.REACT_APP_MANAGER_PREV_START_DATE ? import.meta.env.REACT_APP_MANAGER_PREV_START_DATE : null,
						prevEndDate: import.meta.env.REACT_APP_MANAGER_PREV_END_DATE ? import.meta.env.REACT_APP_MANAGER_PREV_END_DATE : null
					}
				})
			}
		}
	},[driverResponses?.data, getDrivers, currentGroupID])

	useEffect(()=>{
		if (getDriversResponses?.data) {
			//dispatch(setDrivers(getDriversResponses?.data));
			dispatch(setUsers({groupId: currentGroupID, groupUsers:getDriversResponses?.data}))
		}
	},[getDriversResponses?.data, currentGroupID, dispatch])


	var	score = currentDriver?.scorecard

	const currentIndex = findIndex(drivers, driver => driver.userID === currentDriver?.userID)
	const isFirst = drivers.length ? currentIndex === 0 : true;
	const isLast =  drivers.length ? currentIndex === (drivers?.length - 1) : true;

	// const incidents = flatMap(currentDriver?.scorecard, sc => sc.incidents)
	const incidents = currentDriver?.scorecard?.incidents
	const filteredIncidents = buildIncidents(incidents)

	function navigateTo(e, user) {
		navigatToDriverDetail(e, user, Paths.MANAGER_DRIVER_DETAIL, currentGroupID, navigate, dispatch)
		dispatch(incrementBackNavigation())
	}

	function navigateToIncidentDetail(e, incident) {
		const path = replace(Paths.MANAGER_DRIVER_INCIDENT_DETAIL, ':id', currentDriver?.userID).replace(':groupid', currentGroupID).replace(':name', incident.name);
		navigate(path);
	}

	return (
		<Fragment>
			{ driverResponses.loading && <LoadingSpinner />}
			<div className="container" >
				<div className="row">
					<div className="col-12">
						<div className="card">
							<div className="card-body align-items-center" style={{padding: "0.35rem", marginBottom:-6}}>
								<DriverCard  user={ currentDriver} isFirst={isFirst} isLast={isLast} carouselMode={true} navigateLeft={ e => navigateTo(e, drivers[currentIndex - 1]) } navigateRight={ e => navigateTo(e, drivers[currentIndex + 1]) } />
							</div>
						</div>
						
					</div>
				</div>
				{ renderPeriod(currentOrganization) }
				<div className="row">
					<div className="col-12">
						<div className="card" style={{marginBottom: "0 0 0 0 !important"}}>
							<div className="card-body align-items-center" style={{padding: "0.35rem"}}>
								<div className="row text-center g-0 p-0" >
									
									<ScoreTile score={score} />
									<RankProgress score={score} />
									
								</div>
							</div>
						</div>
					</div>
				</div>
				<StreakSection userStreaks={currentDriver?.userStreaks} />
				<div className="row">
					<div className="col-12">
						<div className="card" >
							<div className="card-body align-items-center" style={{padding: "0.35rem"}}>
								<div className="row g-0 p-0">
									{ (filteredIncidents.length > 0) ? (
										<Fragment>
											{ map(filteredIncidents,(incident,index) => {
												return <IncidentCard key={`driver-553-${index}`} currentIncident={incident} onClick={e => navigateToIncidentDetail(e, incident)}/>
											})}
										</Fragment>
									) : (
										<NoContent message={currentDriver?.scorecard?.currentScore ? AppMessages.noIncidents : AppMessages.noDriverScore} showIcon={currentDriver?.scorecard?.currentScore ? true : false} />
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Fragment>
	)
}

export default ManagerDriverDetail;